<template>
  <section>
    <el-row class="condition-bar">
      <el-col :span="24" class>
        <el-col :span="6">
          <label>油站</label>
          <el-select v-model="params.stationId" class="input-width" size="small" placeholder="请选择">
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item, index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <label>油品</label>
          <el-select
            v-model="params.prodId"
            class="input-width"
            clearable
            size="small"
            placeholder="请选择"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item, index) in prodList"
              :key="index"
              :label="item.prodStandard + '-' + item.prodName"
              :value="item.prodId"
            />
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="24">
        <div class="button-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="params.pn=1; getPage()"
          >搜索</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="boss-table" style="padding: 1%">
      <el-col :span="24">
        <el-table v-loading="loading" :data="tableData" style="width: 100%;">
          <el-table-column prop="stationName" label="油站" />
          <el-table-column prop="tankNo" label="油罐编号" />
          <el-table-column prop="prodName" label="油品" />
          <el-table-column prop="surplusVolume" label="当前库存" />
          <el-table-column prop="oilHigh" label="液位高度" />
          <el-table-column prop="lowWarningValue" label="低位预警" />
          <el-table-column prop="highWarningValue" label="高位预警" />
          <el-table-column prop="onLineStatus" label="在线状态" />
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <span
                style="color: #009bf0;cursor: pointer;padding-right: 5%"
                @click="setWarningValue(scope.row)"
              >设置预警值</span>
              <span style="color: #009bf0;cursor: pointer" @click="configPr(scope.row)">配置油品</span>
            </template>
          </el-table-column>
        </el-table>
        <v-pageBox :params="params" @pageBox="pageBox" />
      </el-col>
    </el-row>
    <!--设置预警值-->
    <el-dialog :visible.sync="setWarningValFormVisible" title="设置预警值" width="450px">
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="setWarningValForm"
        label-position="left"
        label-width="130px"
        style="margin:0px 30px;"
      >
        <div style="color: #606266;font-weight: bold;padding-bottom: 2%">
          <p>{{ chooseTankData.stationName }}</p>
          <p>
            <span>{{ chooseTankData.tankNo }}号罐</span>
            <span style="padding-left: 3%">{{ chooseTankData.prodName }}</span>
          </p>
        </div>
        <el-form-item label="低位预警值（L）" prop="lowWarningValue">
          <el-input v-model.number="setWarningValForm.lowWarningValue" type="number" />
        </el-form-item>
        <el-form-item label="高位预警值（L）" prop="highWarningValue">
          <el-input v-model.number="setWarningValForm.highWarningValue" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setWarningValFormVisible = false">取消</el-button>
        <el-button type="primary" @click="updateWarningVal">确认</el-button>
      </div>
    </el-dialog>
    <!--设置油品-->
    <el-dialog :visible.sync="setProdFormVisible" title="设置油品" width="450px">
      <el-form
        ref="prodForm"
        :rules="rules"
        :model="setProdForm"
        label-position="left"
        label-width="130px"
        style="margin:0px 30px;"
      >
        <div style="color: #606266;font-weight: bold;padding-bottom: 2%">
          <p>{{ chooseTankData.stationName }}</p>
          <p>
            <span>{{ chooseTankData.tankNo }}号罐</span>
            <span style="padding-left: 3%">{{ chooseTankData.prodName }}</span>
          </p>
        </div>
        <el-form-item label="国标" prop="prodStandard">
          <el-select v-model="setProdForm.prodStandard" placeholder="请选择油品标准">
            <el-option
              v-for="(value, name) in prFormatObj"
              :value="name"
              :key="name"
              :label="name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="油品" prop="prodId">
          <el-select v-model="setProdForm.prodId" placeholder="请选择油品标准">
            <el-option
              v-for="item in prodList"
              :value="item.prodId"
              :key="item.prodId"
              :label="item.prodName"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联油枪" prop="fpList">
          <el-checkbox-group v-model="setProdForm.fpList">
            <el-checkbox
              v-for="item in fpList"
              :label="item.fpId"
              :key="item.fpId"
              :disabled="(item.oilTankNo)&&item.oilTankNo!=chooseTankData.tankNo"
            >{{ item.fpNo }}号</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setProdFormVisible = false">取消</el-button>
        <el-button type="primary" @click="updateConfigTank">确认</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import PageBox from '@/components/paging/PageBox';
import { stationList } from '@/api/station'; // get油站
import { listProd } from '@/api/product'; // get油品
import { list4gFp } from '@/api/fpConfig'; // 油枪列表
import { checkEmpPwd } from '@/api/setting'; // 密码验证
import { getEmpInfo } from '@/utils/auth';
import {
  getProdFormat,
  oilTankList,
  setWarningVal,
  setOilTank
} from '@/api/stockManage'; // 预警值设置
export default {
  components: {
    'v-pageBox': PageBox
  },
  data () {
    var checkWarningVal = (rule, value, callback) => {
      const reg = /^\d+$/
      if (!reg.test(value) || value > 999999) {
        callback(new Error('请输入大于等于0小于999999的整数'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      params: {
        pn: 1,
        ps: 20,
        pc: 100,
        stationId: getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : ''
      }, // 查询条件参数
      isAllStation: getEmpInfo().isAllStation,
      stationLists: [],
      prodList: [],
      tableData: [
        {
          stationName: '油站A',
          tankNo: '01',
          proName: '95#汽油',
          stockCunt: '100',
          levelHig: '3000',
          lowWarningValue: '100',
          highWarningValue: '10000',
          onLineStatus: '在线'
        },
        {
          stationName: '油站B',
          tankNo: '02',
          proName: '98#汽油',
          stockCunt: '1000',
          levelHig: '3000',
          lowWarningValue: '100',
          highWarningValue: '10000',
          onLineStatus: '脱网'
        }
      ],
      chooseTankData: {},
      setWarningValFormVisible: false,
      setWarningValForm: {
        id: '',
        lowWarningValue: '',
        highWarningValue: ''
      },
      setProdFormVisible: false,
      setProdForm: {
        id: '',
        prodStandard: '',
        prodId: '',
        fpList: []
      },
      prFormatObj: {}, // 国标
      fpList: [], // 油枪列表
      rules: {
        lowWarningValue: [
          {
            validator: checkWarningVal,
            required: true,
            type: 'number',
            trigger: 'blur'
          }
        ],
        highWarningValue: [
          {
            validator: checkWarningVal,
            required: true,
            type: 'number',
            trigger: 'blur'
          }
        ],
        prodStandard: [
          { required: true, message: '请选至少一个油品标准', trigger: 'change' }
        ],
        prodId: [
          { required: true, message: '请选至少选择一种油品', trigger: 'change' }
        ]
        // fpList: [{ type: 'array', required: true, message: '请至少关联一把油枪', trigger: 'change' }]
      }
    }
  },
  created () {
    // 油站列表
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      console.log(row)
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName
          })
        }
      }
    })
    //油品信息
    listProd({}).then(resp => {
      this.prodList = resp.data.data
    })
    getProdFormat({}).then(resp => {
      console.log(resp)
      this.prFormatObj = resp.data.data
    })
    this.getPage()
  },
  methods: {
    // 接受分页子组件参数
    pageBox (...data) {
      console.log(data)
      let pageBoxData = data
      console.log(pageBoxData)
      if (pageBoxData[0] === 'ps') {
        this.params.ps = pageBoxData[1]
      } else {
        this.params.pn = pageBoxData[1]
      }
      console.log(this.params)
      this.getPage()
    },
    // get油罐列表
    getPage () {
      oilTankList(this.params).then(res => {
        if (res.data.code == 0) {
          console.log(res)
          this.tableData = res.data.data.items
          this.params.pc = res.data.data.totalItems
          this.loading = false
        }
      })
    },
    // 获取油枪列表
    getFpData (id) {
      const me = this
      let data = {}
      data.stationId = id
      list4gFp(data).then(function (result) {
        console.log(result)
        me.fpList = result.data.data.items
        me.filterFpList()
      })
    },
    // 筛选已关联油枪
    filterFpList () {
      for (var i in this.fpList) {
        if (this.chooseTankData.tankNo == this.fpList[i].oilTankNo) {
          this.setProdForm.fpList.push(this.fpList[i].fpId)
        }
      }
      console.log(this.setProdForm.fpList)
    },
    // 预警值表单初始化
    resetTemp (data) {
      console.log(data)
      this.setWarningValForm = {
        id: data.id,
        lowWarningValue: data.lowWarningValue,
        highWarningValue: data.highWarningValue
      }
    },
    // 油品配置初始化
    resetPrTemp (data) {
      this.setProdForm = {
        id: data.id,
        prodStandard: data.prodStandard,
        prodId: data.prodId,
        fpList: []
      }
    },
    // 设置预警值
    setWarningValue (data) {
      console.log(data)
      this.chooseTankData = data
      //验证密码
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.resetTemp(data) //数据初始化
            this.setWarningValFormVisible = true //显示新增输入框
            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate() //清楚错误验证
            })
          }
        })
      })
    },
    // 确认设置预警值
    updateWarningVal () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          if (
            this.setWarningValForm.lowWarningValue >=
            this.setWarningValForm.highWarningValue
          ) {
            this.$notify.error({
              title: '错误',
              message: '高位预警值必须大于低位预警值哦！'
            })
          } else {
            setWarningVal(this.setWarningValForm).then(res => {
              if (res.data.code == 0) {
                this.setWarningValFormVisible = false
                this.$notify({
                  title: '成功',
                  message: '操作成功',
                  type: 'success',
                  duration: 2000
                })
                this.getPage()
              }
            })
          }
        }
      })
    },
    // 配置油品
    configPr (data) {
      console.log(data)
      this.chooseTankData = data
      //验证密码
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.getFpData(data.stationId)
            this.resetPrTemp(data) //初始化油品设置
            this.setProdFormVisible = true //显示新增输入框
            this.$nextTick(() => {
              this.$refs['prodForm'].clearValidate() //清楚错误验证
            })
          }
        })
      })
    },
    // 确认配置油品
    updateConfigTank () {
      this.$refs['prodForm'].validate(valid => {
        if (valid) {
          for (const i in this.prodList) {
            if (this.prodList[i].prodId == this.setProdForm.prodId) {
              this.setProdForm.prodName = this.prodList[i].prodName
              break;
            }
          }
          if (this.setProdForm.fpList.length == 0) {
            this.setProdForm.fpIds = '';
          } else {
            this.setProdForm.fpIds = this.setProdForm.fpList.join(',')
          }
          delete this.setProdForm.fpList
          console.log(this.setProdForm)
          setOilTank(this.setProdForm).then(res => {
            if (res.data.code == 0) {
              this.setProdFormVisible = false
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success',
                duration: 2000
              })
              this.getPage()
            }
          })
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.condition-bar {
  padding: 1%;
  background-color: #f2f2f2;
  label {
    padding-right: 3%;
    color: #606266;
  }
  .button-group {
    padding-top: 3%;
    text-align: center;
  }
}
</style>
